export const ViewReportPage_style = {
  rootSx: {
    height: '100vh',
    justifyContent: 'center',
    display: 'flex',
  },
};
